import BusinessPartnerDistributionChainAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partners-dchain/business-partners-dchain.entity";
import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import {
  ReactiveFormsModule,
  FormsModule,
  FormControl,
  FormBuilder,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatOptionModule } from "@angular/material/core";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogModule,
} from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenav, MatSidenavContainer } from "@angular/material/sidenav";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule, MatRowDef } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTooltipModule } from "@angular/material/tooltip";
import {
  NgLabelTemplateDirective,
  NgOptionTemplateDirective,
  NgSelectComponent,
} from "@ng-select/ng-select";
import { ICreateBusinessPartnerChain } from "./interfaces/create-distribution-chain.interface";
import DivisionAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/division/division.entity";
import { DivisionService } from "app/modules/components/configuration/division/division.service.service";
import CompanyAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/company/company.entity";
import { CompanyService } from "app/modules/components/configuration/company/company.service.service";
import SalesOrganizationAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/sales-organization/sales-organization.entity";
import ChannelAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/channel/channel.entity";
import PriceListAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/masters/price-list/price-list.entity";
import { PriceListService } from "app/modules/components/master/price-list/price-list.service";
import { ChannelService } from "app/modules/components/configuration/channel/channel.component.service";
import { SalesOrganizationService } from "app/modules/components/configuration/sales-organization/sales-organization.component.service";
import { DistributionChainService } from "app/modules/components/configuration/distribution-chain/distribution-chain.service";
import DistributionChainAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/distribution-chain/distribution-chain.entity";
import { ReplaySubject, Subject, take, takeUntil } from "rxjs";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { PlantsService } from "app/modules/components/configuration/plant/plants.service";
import { WarehouseService } from "app/modules/components/configuration/warehouse/warehouse.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { FormSectionComponent } from "app/shared/components/form-ui/form-section/form-section.component";
import { UserFieldsConfigurationComponent } from "app/modules/components/configuration/company/user-fields-configuration/user-fields-configuration.component";
import { UserFieldEntityTypeEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/user-field-entity-type.enum";
import { StatusEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/status.enum";
import { UserFieldConfigAttributes } from "@albatrosdeveloper/ave-models-package/lib/schemas/fields-catalog/user-field-catalog/user-field-config/user-field-config.entity";
import { CompanyFieldCatalogService } from "app/modules/components/configuration/company/company-form-config/company-form-config.service";
import {
  buildUserFieldsPayloadForJson,
  clearDynamicUserFieldControls,
  patchUserFieldsFromEntity,
} from "app/utils/user-fields-dynamic-form.util";
import { HandlerMessageService } from "app/common/services/handler-error/handler-message.service";

@Component({
  selector: "app-add-business-partner-modal",
  styleUrl: "./distribution-chain.component.scss",
  templateUrl: "./distribution-chain.component.html",
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatRowDef,
    MatSidenav,
    MatSidenavContainer,
    FormsModule,
    NgLabelTemplateDirective,
    NgOptionTemplateDirective,
    NgSelectComponent,
    MatSelectModule,
    MatTabsModule,
    NgxMatSelectSearchModule,
    FormSectionComponent,
    UserFieldsConfigurationComponent
  ],
})
export class AddDistributionChainComponent {
  currentCreateBusinessPartnerChain: ICreateBusinessPartnerChain =
    this.initializeCreateBusinessPartner();
  currentUpdateBusinessPartnerChain:
    | BusinessPartnerDistributionChainAttributes
    | undefined;

  selectedDivisionIds: string[] = [];

  distributionChainList: DistributionChainAttributes[] = [];
  companyList: CompanyAttributes[] = [];
  salesOrganizationList: SalesOrganizationAttributes[] = [];
  channelList: ChannelAttributes[] = [];
  priceList: PriceListAttributes[] = [];
  discountList: PriceListAttributes[] = [];
  giftList: PriceListAttributes[] = [];
  divisionList: DivisionAttributes[] = [];
  allWarehouses: { [key: string]: any[] } = {};


  
    /** control for the selected alternalPrice for multi-selection */
  public alternalGiftMultiCtrl: FormControl<PriceListAttributes[]> =
    new FormControl<PriceListAttributes[]>([], Validators.required);

  /** control for the MatSelect filter keyword multi-selection */
  public alternalGiftMultiFilterCtrl: FormControl<string> =
    new FormControl<string>("");

  /** list of alternalPrice filtered by search keyword */
  public filteredalternalGift: ReplaySubject<PriceListAttributes[]> =
    new ReplaySubject<PriceListAttributes[]>(1);

  /** local copy of filtered alternalPrice to help set the toggle all checkbox state */
  protected filteredalternalGiftCache: PriceListAttributes[] = [];

  /** flags to set the toggle all checkbox state */
  isIndeterminateGift = false;
  isCheckedGift = false;


    /** control for the selected alternalPrice for multi-selection */
  public alternalDiscountMultiCtrl: FormControl<PriceListAttributes[]> =
    new FormControl<PriceListAttributes[]>([], Validators.required);

  /** control for the MatSelect filter keyword multi-selection */
  public alternalDiscountMultiFilterCtrl: FormControl<string> =
    new FormControl<string>("");

  /** list of alternalPrice filtered by search keyword */
  public filteredalternalDiscount: ReplaySubject<PriceListAttributes[]> =
    new ReplaySubject<PriceListAttributes[]>(1);

  /** local copy of filtered alternalPrice to help set the toggle all checkbox state */
  protected filteredalternalDiscountCache: PriceListAttributes[] = [];

  /** flags to set the toggle all checkbox state */
  isIndeterminateDiscount = false;
  isCheckedDiscount = false;




  /** control for the selected alternalPrice for multi-selection */
  public alternalPriceMultiCtrl: FormControl<PriceListAttributes[]> =
    new FormControl<PriceListAttributes[]>([], Validators.required);

  /** control for the MatSelect filter keyword multi-selection */
  public alternalPriceMultiFilterCtrl: FormControl<string> =
    new FormControl<string>("");

  /** list of alternalPrice filtered by search keyword */
  public filteredalternalPrice: ReplaySubject<PriceListAttributes[]> =
    new ReplaySubject<PriceListAttributes[]>(1);

  /** local copy of filtered alternalPrice to help set the toggle all checkbox state */
  protected filteredalternalPriceCache: PriceListAttributes[] = [];

  /** flags to set the toggle all checkbox state */
  isIndeterminate = false;
  isChecked = false;
  isEditMode: boolean;
  plants: any[] = [];
  warehouses: any[] = [];

  protected _onDestroy = new Subject<void>();

  fieldsMasterData: UserFieldConfigAttributes[] = [];
  fieldsMasterDataStatus: StatusEnum;
  userFieldsForm: FormGroup = new FormGroup({});

  constructor(
    private plantService: PlantsService,
    private warehouseService: WarehouseService,
    private readonly divisionService: DivisionService,
    private readonly companyService: CompanyService,
    private readonly priceListService: PriceListService,
    private readonly channelService: ChannelService,
    private readonly salesOrganizationService: SalesOrganizationService,
    private distributionChainService: DistributionChainService,
    public dialogRef: MatDialogRef<AddDistributionChainComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, // Optional: if you want to pass data
    private snackBar: MatSnackBar,
    private companyFieldCatalogService: CompanyFieldCatalogService,
    private fb: FormBuilder,
    private handlerMessage: HandlerMessageService
  ) {
    this.isEditMode = !!data;
    if (this.isEditMode) {
      this.currentCreateBusinessPartnerChain = {
        ...data,
        distributionChainId: data._id,
        businessPartnerPriceListId: data?.ownPriceList?._id || null,
        businessPartnerDiscountListId: data?.ownDiscountList?._id || null,
        businessPartnerGiftListId: data?.ownGiftList?._id || null,
        alternalPriceListIds: data.alternalPriceList
          ? data.alternalPriceList.map((price) => price._id.toString())
          : null,
        alternalDiscountListIds: data.alternalDiscountList
          ? data.alternalDiscountList.map((price) => price._id.toString())
          : null,
        alternalGiftListIds: data.alternalGiftList
          ? data.alternalGiftList.map((price) => price._id.toString())
          : null,
        plantId: data.plant?._id.toString() || null,
        warehouseId: data.warehouse?._id.toString() || null,
        divisionIds: data.divisions
        ? data.divisions.map((div) => div._id.toString())
        : null,
      };
    }
  }

  ngOnInit(): void {
    this.loadPlants();
    if (this.isEditMode && this.currentCreateBusinessPartnerChain.plantId) {
      this.loadWarehouses(this.currentCreateBusinessPartnerChain.plantId);
    }    
  }

  loadFieldsMasterData(): void {
      this.companyFieldCatalogService.getFieldsMaster(this.companyList[0]._id.toString(), UserFieldEntityTypeEnum.BP_DISTRIBUTION_CHAIN)
      .pipe(take(1))
      .subscribe({
        next: (res) => {
          this.fieldsMasterDataStatus = res.data.statusId;
          this.fieldsMasterData = res.data.fields;
          clearDynamicUserFieldControls(this.userFieldsForm, []);
          patchUserFieldsFromEntity(
            this.userFieldsForm,
            this.fb,
            this.fieldsMasterData,
            this.data ?? {}
          );
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error fetching fields master data",
            "Cerrar",
            { duration: 5000 }
          );
        },
      });
    }

  private fetchDivisions(): void {
    this.divisionService.findToComboBox().subscribe((res) => {
      this.divisionList = res.data;
    });
  }

  ngAfterViewInit(): void {
    // this.setupPaginationAndSorting();
    this.fetchAllCompanies();
    this.fetchAllDivision();
    this.fetchDivisions();
    this.fetchAllPriceList();
    this.fetchAlldDiscountList();
    this.fetchAlldGiftList();
    this.fetchAllChannel();
    this.fetchAllSalesOrganization();
    // this.findAllWithCount();    
  }

  private fetchAllDivision(): void {
    this.distributionChainService.findToComboBox().subscribe({
      next: (res) => {
        this.distributionChainList = res.data;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener divisiones.","Cerrar",{ duration: 5000});
      },
    });
  }

  private fetchAllSalesOrganization(): void {
    this.salesOrganizationService.findToComboBox().subscribe({
      next: (res) => {
        this.salesOrganizationList = res.data;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener organizaciones de ventas.","Cerrar",{ duration: 5000});
      },
    });
  }

  private fetchAllCompanies(): void {
    this.companyService.findToComboBox().subscribe({
      next: (res) => {
        this.companyList = res.data;

        this.loadFieldsMasterData();
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener compañias.","Cerrar",{ duration: 5000});
      },
    });
  }

  private fetchAllPriceList(): void {
  this.priceListService.findToComboBoxPriceList("P").subscribe({
    next: (res) => {
      this.priceList = res.data;
      
      this.filterAndSetAlternalPriceList();
      
      if (this.isEditMode && this.currentCreateBusinessPartnerChain.alternalPriceListIds) {
          const selectedPrices = this.priceList.filter(price => 
              this.currentCreateBusinessPartnerChain.alternalPriceListIds.includes(price._id.toString())
          );
          this.alternalPriceMultiCtrl.setValue(selectedPrices);
      }

      this.alternalPriceMultiFilterCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
          this.filterRouteMulti();
          this.setToggleAllCheckboxState();
        });
    },
    error: (err) => {
      this.snackBar.open(err.error.message || "Error al obtener listas de precios.","Cerrar",{ duration: 5000});
    },
  });
}

protected filterAndSetAlternalPriceList(): void {
    const mainPriceId = this.currentCreateBusinessPartnerChain.businessPartnerPriceListId;
    
    let filteredList = this.priceList;
    
    if (mainPriceId) {
        filteredList = this.priceList.filter(price => price._id.toString() !== mainPriceId);
    }
    
    this.filteredalternalPriceCache = filteredList;
    this.filteredalternalPrice.next(filteredList);
    
    this.filterRouteMulti();
    this.setToggleAllCheckboxState();
}

  protected filterRouteMulti() {
  if (!this.filteredalternalPriceCache) {
    return;
  }

  let search = this.alternalPriceMultiFilterCtrl.value;
  if (!search) {
    this.filteredalternalPrice.next(this.filteredalternalPriceCache);
    return;
  } else {
    search = search.toLowerCase();
  }

  const filtered = this.filteredalternalPriceCache.filter((material) => {
    const nameMatches = material.name.toLowerCase().indexOf(search) > -1;
    const codeMatches = material?.code?.toLowerCase().indexOf(search) > -1;
    return nameMatches || codeMatches;
  });
  this.filteredalternalPrice.next(filtered);
}

  toggleSelectAll(selectAllValue: boolean) {
    this.filteredalternalPrice
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe((val) => {
        if (selectAllValue) {
          this.alternalPriceMultiCtrl.patchValue(val);
        } else {
          this.alternalPriceMultiCtrl.patchValue([]);
        }
      });
  }
  protected setToggleAllCheckboxState() {
    let filteredLength = 0;
    if (this.alternalPriceMultiCtrl && this.alternalPriceMultiCtrl.value) {
      this.filteredalternalPriceCache.forEach((el) => {
        if (this.alternalPriceMultiCtrl.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminate =
        filteredLength > 0 &&
        filteredLength < this.filteredalternalPriceCache.length;
      this.isChecked =
        filteredLength > 0 &&
        filteredLength === this.filteredalternalPriceCache.length;
    }
  }

  private fetchAlldDiscountList(): void {
    this.priceListService.findToComboBoxDiscountList().subscribe({
      next: (res) => {
        this.discountList = res.data;
        
        this.filterAndSetAlternalDiscountList();

        if (this.isEditMode && this.currentCreateBusinessPartnerChain.alternalDiscountListIds) {
            const selectedDiscounts = this.discountList.filter(discount => 
                this.currentCreateBusinessPartnerChain.alternalDiscountListIds.includes(discount._id.toString())
            );
            this.alternalDiscountMultiCtrl.setValue(selectedDiscounts);
        }

        this.alternalDiscountMultiFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filterRouteMultiD();
            this.setToggleAllCheckboxStateD();
          });
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener descuentos.","Cerrar",{ duration: 5000});
      },
    });
  }

  protected filterAndSetAlternalDiscountList(): void {
      const mainDiscountId = this.currentCreateBusinessPartnerChain.businessPartnerDiscountListId;
      
      let filteredList = this.discountList;
      
      if (mainDiscountId) {
          filteredList = this.discountList.filter(discount => discount._id.toString() !== mainDiscountId);
      }
      
      this.filteredalternalDiscountCache = filteredList;
      this.filteredalternalDiscount.next(filteredList);
      

      this.filterRouteMultiD();
      this.setToggleAllCheckboxStateD();
  }

    protected filterRouteMultiD() {
    if (!this.filteredalternalDiscountCache) {
      return;
    }

    let search = this.alternalDiscountMultiFilterCtrl.value;
    if (!search) {
      this.filteredalternalDiscount.next(this.filteredalternalDiscountCache);
      return;
    } else {
      search = search.toLowerCase();
    }

    const filtered = this.filteredalternalDiscountCache.filter((material) => {
      const nameMatches = material.name.toLowerCase().indexOf(search) > -1;
      const codeMatches = material?.code?.toLowerCase().indexOf(search) > -1;
      return nameMatches || codeMatches;
    });
    this.filteredalternalDiscount.next(filtered);
  }

  toggleSelectAllDiscount(selectAllValue: boolean) {
    this.filteredalternalDiscount
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe((val) => {
        if (selectAllValue) {
          this.alternalDiscountMultiCtrl.patchValue(val);
        } else {
          this.alternalDiscountMultiCtrl.patchValue([]);
        }
      });
  }
  protected setToggleAllCheckboxStateD() {
    let filteredLength = 0;
    if (this.alternalDiscountMultiCtrl && this.alternalDiscountMultiCtrl.value) {
      this.filteredalternalDiscountCache.forEach((el) => {
        if (this.alternalDiscountMultiCtrl.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminateDiscount =
        filteredLength > 0 &&
        filteredLength < this.filteredalternalDiscountCache.length;
      this.isCheckedDiscount =
        filteredLength > 0 &&
        filteredLength === this.filteredalternalDiscountCache.length;
    }
  }

  private fetchAlldGiftList(): void {
    this.priceListService.findToComboBoxGiftList().subscribe({
      next: (res) => {
        this.giftList = res.data;
        
        this.filterAndSetAlternalGiftList();
        
        if (this.isEditMode && this.currentCreateBusinessPartnerChain.alternalGiftListIds) {
            const selectedGifts = this.giftList.filter(gift => 
                this.currentCreateBusinessPartnerChain.alternalGiftListIds.includes(gift._id.toString())
            );
            this.alternalGiftMultiCtrl.setValue(selectedGifts);
        }

        this.alternalGiftMultiFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filterRouteMultiG();
            this.setToggleAllCheckboxStateG();
          });
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener listas de regalos.","Cerrar",{ duration: 5000});
      },
    });
  }

  protected filterAndSetAlternalGiftList(): void {
    const mainGiftId = this.currentCreateBusinessPartnerChain.businessPartnerGiftListId;
    
    let filteredList = this.giftList;
    
    if (mainGiftId) {
        filteredList = this.giftList.filter(gift => gift._id.toString() !== mainGiftId);
    }
    
    this.filteredalternalGiftCache = filteredList;
    this.filteredalternalGift.next(filteredList);
    
    this.filterRouteMultiG();
    this.setToggleAllCheckboxStateG();
  }

    protected filterRouteMultiG() {
    if (!this.filteredalternalGiftCache) {
      return;
    }

    let search = this.alternalGiftMultiFilterCtrl.value;
    if (!search) {
      this.filteredalternalGift.next(this.filteredalternalGiftCache);
      return;
    } else {
      search = search.toLowerCase();
    }

    const filtered = this.filteredalternalGiftCache.filter((material) => {
      const nameMatches = material.name.toLowerCase().indexOf(search) > -1;
      const codeMatches = material?.code?.toLowerCase().indexOf(search) > -1;
      return nameMatches || codeMatches;
    });
    this.filteredalternalGift.next(filtered);
  }

  toggleSelectAllGift(selectAllValue: boolean) {
    this.filteredalternalGift
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe((val) => {
        if (selectAllValue) {
          this.alternalGiftMultiCtrl.patchValue(val);
        } else {
          this.alternalGiftMultiCtrl.patchValue([]);
        }
      });
  }
  protected setToggleAllCheckboxStateG() {
    let filteredLength = 0;
    if (this.alternalGiftMultiCtrl && this.alternalGiftMultiCtrl.value) {
      this.filteredalternalGiftCache.forEach((el) => {
        if (this.alternalGiftMultiCtrl.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminateGift =
        filteredLength > 0 &&
        filteredLength < this.filteredalternalGiftCache.length;
      this.isCheckedGift =
        filteredLength > 0 &&
        filteredLength === this.filteredalternalGiftCache.length;
    }
  }

  private fetchAllChannel(): void {
    this.channelService.findToComboBox().subscribe({
      next: (res) => {
        this.channelList = res.data;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener compañias.","Cerrar",{ duration: 5000});
      },
    });
  }

  private initializeCreateBusinessPartner(): ICreateBusinessPartnerChain {
    return {
      distributionChainId: [],
      interlocutors: [],
      businessPartnerPriceListId: null,
      plantId: null,
      warehouseId: null,
    };
  }
  onPlantsSelectionChange(plantId: string): void {
    this.currentCreateBusinessPartnerChain.warehouseId = null;

    if (!this.isEditMode) {
      this.loadWarehouses(plantId);
    } else {
      if (this.currentCreateBusinessPartnerChain) {
        this.currentCreateBusinessPartnerChain.plantId = plantId;
        // this.currentCreateBusinessPartnerChain.plantId = this.plants.find(
        //   (plant) => plant._id.toString() === plantId
        // )!;
      }
      this.loadWarehouses(plantId);
    }
  }

  onWarehouseSelectionChange(warehouseId: string): void {
    if (!this.isEditMode) {
      this.currentCreateBusinessPartnerChain.warehouseId = null;
    } else {
      if (this.currentCreateBusinessPartnerChain) {
        this.currentCreateBusinessPartnerChain.warehouseId = warehouseId;
        // this.currentCreateBusinessPartnerChain.warehouseId =
        //   this.warehouses.find(
        //     (plant) => plant._id.toString() === warehouseId
        //   )!;
      }
    }
  }

  private loadPlants(): void {
    this.plantService.findToComboBox().subscribe({
      next: (response: any) => {
        this.plants = response.data || [];
        if (this.isEditMode) {
          this.onPlantsSelectionChange(
            this.currentCreateBusinessPartnerChain.plantId
          );
        } else {
          this.onPlantsSelectionChange(
            this.currentCreateBusinessPartnerChain.plantId
          );
        }
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener plantas.","Cerrar",{ duration: 5000});
      },
    });
  }

  compareById(item1: any, item2: any): boolean {
    return item1 && item2
      ? item1._id.toString() === item2.toString()
      : item1 === item2;
  }

  private loadWarehouses(plantId: string): void {
    this.warehouseService.findToComboBox(plantId).subscribe({
      next: (response: any) => {
        this.allWarehouses[plantId] = response.data || [];
        this.updateWarehouses(plantId);
        if (this.isEditMode) {
          this.currentCreateBusinessPartnerChain.warehouseId =
            this.data.warehouse._id;
        } else {
          this.currentCreateBusinessPartnerChain.warehouseId =
            this.warehouses[0]?._id || null;
        }

        this.onWarehouseSelectionChange(
          this.currentCreateBusinessPartnerChain.warehouseId
        );
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener almacenes.","Cerrar",{ duration: 5000});
      },
    });
  }

  updateWarehouses(plantId): void {
    const selectedPlantId = plantId;
    this.warehouses = this.allWarehouses[selectedPlantId] || [];
  }

  async save(): Promise<void> {
    // The parent sends this chain inside a JSON body, so attachments are read to base64
    // here. A `File` left inside would serialize to `{}` and the API would reject it.
    if (this.fieldsMasterData?.length) {
      try {
        this.currentCreateBusinessPartnerChain.userFields =
          await buildUserFieldsPayloadForJson(
            this.userFieldsForm.getRawValue(),
            this.fieldsMasterData
          );
      } catch {
        this.handlerMessage.error({ message: "No se pudo leer el archivo adjunto" });
        return;
      }
    }
    
    //   const selectedGift = this.giftList.find(
    //     item => item._id.toString() === this.currentCreateBusinessPartnerChain.businessPartnerGiftListId
    // );

    //    if (!selectedGift) {
    //     this.currentCreateBusinessPartnerChain.businessPartnerGiftListId = null;
    //     return;
    // }

    (this.currentCreateBusinessPartnerChain.alternalPriceListIds =
      this.alternalPriceMultiCtrl.value.map((price: PriceListAttributes) =>
        price._id.toString()
      )),
       (this.currentCreateBusinessPartnerChain.alternalDiscountListIds =
      this.alternalDiscountMultiCtrl.value.map((price: PriceListAttributes) =>
        price._id.toString()
      )),
        (this.currentCreateBusinessPartnerChain.alternalGiftListIds =
      this.alternalGiftMultiCtrl.value.map((price: PriceListAttributes) =>
        price._id.toString()
      )),
      this.dialogRef.close(this.currentCreateBusinessPartnerChain);
  }
}
